import React from "react";
import { HeaderModule } from '../../../components/home/HeaderModule';
import { StyleOutlined } from "@mui/icons-material";
import { ActionsBar } from "../../../components/ActionsBar";
import { TableModule } from "../../../components/home/TableModule";
import { useServices } from "../../../hooks/encuestas/useServices";

export const Services = () => {

    const { columns, services, addService, searchService } = useServices();

    return (
        <>
            <HeaderModule 
                icon={ <StyleOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Servicios'
            />

            <ActionsBar 
                addAction={ addService } 
                module='servicios'
                searchAction={ searchService } 
                searchPlaceholder='Servicio' 
            />

            <TableModule
                columns={ columns }
                rows={ services }
                styles={{
                    background: '#fff',
                    borderRadius: 6,
                    marginTop: 10,
                }}
            />
        </>
    )
};